module.exports = __webpack_public_path__ + "img/partfour_pic3.0d7c2767.jpeg";